import React from "react";
import PropTypes from "prop-types";
import {
    fetchNewDocumentsChecklist
} from "store/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Table } from "components";
import {
    Row,
    Col,
    // Spin
    // Dropdown, Menu, Icon
} from "antd";
import PopMenu from "components/PopMenu";
import { DOCUMENT_CHECKLIST_COLS } from "constants/table-columns";
import { List } from "immutable";
// import { STATE_STATUS } from "constants/index";

// const createViewAction = action => {
//     const _ = () => (
//         <a href="javascript:void(0)" onClick={() => action()}>
//             View
//         </a>
//     );
//     _.displayName = "TableAction";
//     return _;
// };

class DocumentChecklistViewPage extends React.Component {
    componentDidMount() {
        this.props.fetchNewDocumentsChecklist();
    }

    handleItemClick = () => {
        this.props.history.push("/app/checklist/new");
    };

    render() {
        // if(this.props.programListStatus === STATE_STATUS.UNFETCHED || this.props.programListStatus === STATE_STATUS.FETCHING) {
        //     return "FETCHING";
        // }
        return (
            <Row className={"p-5"}>
                <Col span={24}>
                    <PopMenu
                        icon={"plus"}
                        onItemClick={this.handleItemClick}
                        menuList={["Create Document Checklist"]}
                    />
                    <Table
                        columns={DOCUMENT_CHECKLIST_COLS}
                        // data={new List(this.props.programListData && this.props.programListData.map(_ => {
                        //     let row = _;
                        //     row.action = createViewAction(
                        //         this.props.history.push.bind(null, `/app/checklist/${_.id}`)
                        //     )();
                        //     return row;
                        // })) || new List([])}
                        data={new List([])}
                        showTopSection={false}
                    />
                </Col>  
            </Row>
        );
    }
}

DocumentChecklistViewPage.propTypes = {
    permission: PropTypes.string,
    history: PropTypes.object,
    programListData: PropTypes.array,
    programListStatus: PropTypes.string,
    fetchNewDocumentsChecklist: PropTypes.func
};

const mapStateToProps = state => ({
    programListStatus: state.schemes.getIn(["business_program_list", "status"]),
    programListData: state.schemes.getIn(["business_program_list", "data"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchNewDocumentsChecklist
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps) (DocumentChecklistViewPage);